"use client";
import { Stack } from "@mui/material";

import { useStore, observer } from "../../../../service/mobx";
import ChipFilter from "../../../../component/Chip/Filter";
import { filterChipScrollSx } from "../../../search/Filters";

function TabsSelector({ tab }) {
  const { analytics, device, reader } = useStore();
  const tabs = [
    { label: "Paper", url: "paper" },
    ...reader.relatedContentFiltered.map(([label, , , url]) => ({ label, url }))
  ];

  return device.isPhone ||
    (device.isTablet && reader.whiteLabelled === false) ? (
    <Stack
      zIndex={1}
      direction="row"
      spacing={1}
      mx={{ compact: -2, expanded: -3 }}
      p={2}
      sx={filterChipScrollSx}
    >
      {tabs.map(({ label, url }) => (
        <ChipFilter
          key={url}
          small
          href={url}
          label={label}
          selected={url === tab}
          onClick={() => {
            analytics.track.event("Related Filter", {
              type: tab,
              value: url
            });
          }}
        />
      ))}
    </Stack>
  ) : null;
}

export default observer(TabsSelector);

/*
 // return (
  //   <Tabs
  //     value={
  //       (lgScreen === false && panel) || tab || (paper ? "paper" : "model")
  //     }
  //     sx={{ borderBottom: 1, borderColor: "outline.variant", mt: 3 }}
  //   >
  //     {tabs.map(({ label, Icon, url }) => (
  //       <Tab
  //         key={label}
  //         iconPosition="start"
  //         value={label}
  //         href={url}
  //         LinkComponent={Link}
  //         sx={{ color: "surface.on.color", minHeight: 48 }}
  //         icon={<Icon sx={{ width: 16, height: 16 }} />}
  //         label={<Typography variant="titleSm">{label}</Typography>}
  //       />
  //     ))}

  //     {supportPanes.map(([label, url]) => (
  //       <Tab
  //         key={label}
  //         value={label}
  //         href={url}
  //         LinkComponent={Link}
  //         sx={{
  //           minHeight: 48,
  //           color: "surface.on.color",
  //           display: { expanded: "flex", large: "none" }
  //         }}
  //         label={<Typography variant="titleSm">{label}</Typography>}
  //       />
  //     ))}
  //   </Tabs>
  // );
*/
